<template>
  <div class="box">
    <!-- <b v-if="car_data['active_bidding'][0]['sale_date'] != null"
      >Data aukcji:
    </b> -->
    <!-- <p v-if="car_data['active_bidding'][0]['sale_date'] != null">
      {{ format_date(car_data["active_bidding"][0]["sale_date"]) }}
    </p> -->

    <div class="row">
      <div class="current_bid" v-if="car_data['active_bidding'][0] != null">
        <p>AKTUALNA OFERTA:</p>
        <p>${{ car_data["active_bidding"][0]["current_bid"] }}</p>
      </div>
    </div>
    <p class="show_history">
      <b>Historia sprzedaży</b>
    </p>

    <div>
      <p v-if="car_data['sales_history'].length == 0" class="no_history">
        Brak historii samochodu.
      </p>
      <table class="table" v-else>
        <tr>
          <th>Data</th>
          <th>Finalna oferta</th>
          <th>Lot</th>
          <th>Status</th>
        </tr>
        <tr v-for="sale in car_data['sales_history']" :key="sale['id']">
          <td>{{ formatDate(sale["sale_date"]) }}</td>
          <td>{{ sale["purchase_price"] }} $</td>
          <td>{{ sale["lot_number"] }}</td>
          <td>{{ sale["sale_status"] }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import moment from "moment";
export default {
  name: "AuctionInfo",
  props: ["car_data"],
  data() {
    return {
      show_sale_history: false,
    };
  },
  methods: {
    formatDate(unixTimestamp) {
      // Przekształcenie timestampu w milisekundy
      const date = new Date(unixTimestamp * 1);

      // Uzyskanie elementów daty
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Miesiące są od 0 do 11, więc dodajemy 1
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      // Formatowanie daty
      return `${day}-${month}-${year} ${hours}:${minutes}`;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box {
  margin-bottom: 40px;
}
.calculator .current_bid {
  display: flex;
  width: 90%;
  justify-content: space-between;
  gap: 16px;
  padding: 21px 24px 22px 24px;
  background-color: #011f68;
  margin-bottom: 15px;
}
.calculator .current_bid p {
  font-family: "bicyclette";
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  color: #fff;
  margin: 0;
}
.calculator .show_history {
  margin: 0 0 5px;
  font-family: "bicyclette";
  font-size: 13px;
  font-weight: 700;
  line-height: 16.9px;
  color: #011f68;
}

/* to elem p with text ' Brak histori samochodu. ' add class no_history  */
.calculator .no_history {
  font-family: "bicyclette";
  font-size: 13px;
  font-weight: 400;
  line-height: 16.9px;
  margin: 0;
  color: #011f68;
}
.table {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 95%;
}

.table td,
.table th {
  border: 1px solid #ddd;
  padding: 5px;
}

.table tr:nth-child(even) {
  background-color: #f2f2f2;
}

.table tr:hover {
  background-color: #ddd;
}

.table th {
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: left;
  background-color: #011f68;
  color: white;
}
</style>
